import {Component, OnInit} from '@angular/core';
import {ClientService} from '../services/client.service';
import {NavbarComponent} from '../components/navbar/navbar.component';
import {NgForOf, NgIf} from '@angular/common';
import {SafePipe} from '../pipe/safe.pipe';

export interface Agency {
  id: number;
  name: string;
  powerbiLink: string;
}

@Component({
  selector: 'app-stats',
  imports: [
    NavbarComponent,
    NgForOf,
    NgIf,
    SafePipe
  ],
  templateUrl: './stats.component.html',
  styleUrl: './stats.component.css',
  providers: [ClientService]
})
export class StatsComponent implements OnInit {

  public agencies: Agency[] = [];

  public iframeOpened = false;
  public iframeSrc: string = "";

  constructor(private clientService: ClientService) {
  }

  ngOnInit() {
    this.clientService.getMy().subscribe({
      next: data => {
        console.log(data);
        this.agencies = data;
      },
      error: err => {
        console.log(err);
      }
    })
  }

  openIframe(powerbiLink: string) {
    this.iframeOpened = true;
    this.iframeSrc = powerbiLink;
  }
}
